import { useEffect, useState } from 'react'

import { ConfirmDialog } from '@/shared/ui/ConfirmDialog'

export const DigitalProductStoreWithdrawConfirmModal = ({
  onHide,
  onCancel,
  onConfirm
}) => {
  const [isWaitingRead, setIsWaitingRead] = useState(true)

  // 1,25s, e não 1,5s: o gesto de segurar que abre este modal já cobra 1s. As
  // duas travas foram calibradas em separado, cada uma como se fosse a única, e
  // somadas davam 3s até a confirmação — tempo que a fila paga. A barreira
  // dupla continua; o total é 2,25s.
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsWaitingRead(false)
    }, 1250)

    return () => clearTimeout(timer)
  }, [])

  return (
    <ConfirmDialog
      title="Atenção!"
      description={
        <>
          <span className="mb-1 block text-base font-bold text-gray-900">
            Você tem certeza que recebeu o item?
          </span>
          Após a confirmação, você não poderá retirar o item novamente
        </>
      }
      confirmLabel="Confirmar"
      confirmLoading={isWaitingRead}
      onCancel={() => {
        onCancel()
        onHide()
      }}
      onConfirm={() => {
        onConfirm()
        onHide()
      }}
    />
  )
}
